import { cn } from "~/lib/utils";

// // // //

interface Props {
    label?: string;
    placeholder?: string;
    value: string;
    required?: boolean;
    disabled?: boolean;
    minLength?: number;
    name?: string;
    type?: "text" | "email";
    size?: "xs" | "sm" | "md";
    block?: boolean;
    className?: string;
    disableAutofill?: boolean;
    getValidityMessage?: (validityState: ValidityState) => string | null;
    onChange: (updatedValue: string) => void;
}

export function TextInput(props: Props) {
    const {
        label,
        value,
        required,
        disabled,
        minLength,
        type = "text",
        size = "md",
        block = false,
        disableAutofill = false,
        getValidityMessage = null,
        onChange,
        name,
        className,
        placeholder,
    } = props;

    return (
        <div
            className={cn(
                className,
                "border-2 border-blue-200 focus-within:border-blue-500 focus-within:ring-2 focus-within:ring-blue-500/20 bg-card select-none transition-all duration-200",
                {
                    "px-1 py-0.5 rounded-xs": size === "xs",
                    "px-1 py-1 rounded-xs": size === "sm",
                    "px-3 py-2 rounded-lg": size === "md",
                    "w-full": block,
                },
            )}
        >
            {label && (
                <label
                    htmlFor={name}
                    className="block text-xs text-slate-700 font-medium"
                >
                    {label}
                </label>
            )}
            <input
                type={type}
                className="block w-full border-0 p-0 text-slate-900 placeholder-slate-500 focus:ring-0 text-base bg-card"
                name={name}
                {...(disableAutofill && {
                    autoComplete: "off",
                    autoCorrect: "off",
                    autoCapitalize: "off",
                    spellCheck: "false",
                    "data-form-type": "other",
                    "data-1p-ignore": "",
                    "data-lpignore": "true",
                })}
                required={required}
                disabled={disabled}
                minLength={minLength}
                value={value}
                placeholder={placeholder}
                onChange={(e) => {
                    onChange(e.currentTarget.value);
                    if (getValidityMessage !== null) {
                        e.currentTarget.checkValidity();
                    }
                }}
                onInvalid={(e) => {
                    if (getValidityMessage === null) {
                        return;
                    }

                    const message = getValidityMessage(
                        e.currentTarget.validity,
                    );

                    if (!message) {
                        e.currentTarget.setCustomValidity("");
                        return;
                    }

                    // Set custom message
                    e.currentTarget.setCustomValidity(message);
                }}
            />
        </div>
    );
}
